import request from '@/utils/request'
const url = '/receipt';
export function getReceipt(params) {
    return request({
        url: url + '/getReceipt',
        method: 'get',
        params: params
    })
}


export function updateReceipt(data) {
    return request({
      url: url + '/updateReceipt',
      method: 'post',
      data: data
    })
  }


// WEBPACK FOOTER //
// ./src/api/receipt.js